var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalentBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.213 32.414A2 2 0 0122.8 33H11.201a2 2 0 01-1.414-.586l-8.201-8.2A2 2 0 011 22.798V11.201a2 2 0 01.586-1.414l8.2-8.201A2 2 0 0111.202 1h11.598a2 2 0 011.414.586l8.201 8.2A2 2 0 0133 11.202v11.598a2 2 0 01-.586 1.414l-8.2 8.201z",
    stroke: "#000",
    strokeWidth: 2
  })));
}
export default __webpack_public_path__ + "static/svg/talenttree/Talent_Border.svg";
export { SvgTalentBorder as ReactComponent };